// extracted by mini-css-extract-plugin
module.exports = {"level-2-bg":"StaffGrid_level-2-bg__TvKUw","grid":"StaffGrid_grid__tRGWz"};